import { useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import { numberWithCommas, moveScrollTop } from '@utils/index';
import type { l10nType } from '@type/index';

/**
 * 전체 - 더보기
 */
interface IAllMore {
  name: string;
  l10n: l10nType;
  url: string;
  type?: 'ROUTE' | 'LINK';
  count?: number;
}

const AllMore = ({ type, name, count, l10n, url }: IAllMore) => {
  const routeClickCallback = useCallback(() => {
    moveScrollTop();
  }, []);

  return (
    <div className="all-more">
      {type === 'ROUTE' ? (
        <NavLink to={url} onClick={routeClickCallback}>
          {name}
          {typeof count === 'number' && count > 0 ? ` (${numberWithCommas(count)}${l10n?.template?.count})` : ''}
        </NavLink>
      ) : (
        <a href={url}>
          {name}
          {typeof count === 'number' && count > 0 ? ` (${numberWithCommas(count)}${l10n?.template?.count})` : ''}
        </a>
      )}
    </div>
  );
};

export default AllMore;
